import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { ChartStatisticsFilterForm, StatisticsFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { AverageWithRate, TotalWithRate } from '../../interface';
import { Mapper } from '../mapper/mapper';
import {
  EnthusiastsStatisticsModel,
  WhiteLabelChartStatistics,
  WhiteLabelMapStatisticsModel,
  WhiteLabelPdfGendersStatistics,
  WhiteLabelTotalWithAverageSessions,
  WhiteLabelUsersCommentsWithRate,
} from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class WhiteLabelDashboardApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getQuranEnthusiastsStatistics(): Observable<EnthusiastsStatisticsModel> {
    return this.baseAPI.post(Constants.GET_QURAN_ENTHUSIASTS_STATISTICS_API_URL, {}).pipe(
      map((res) => {
        return this.mapper.fromJson(EnthusiastsStatisticsModel, res);
      })
    );
  }

  getApplicationTotalSessionData(form: StatisticsFilterForm): Observable<WhiteLabelTotalWithAverageSessions> {
    const body = {
      from: form.date?.start || null,
      to: form.date?.end || null,
      categories: form.categories ? [form.categories] : undefined,
    };
    return this.baseAPI.post(Constants.GET_APPLICATION_TOTAL_SESSIONS_API_URL, body).pipe(
      map((res) => {
        for (const key in res.totals) {
          Object.values(res.totals[key]);
          const newObject: TotalWithRate = {
            total: Object.values(res.totals[key])[0] as number,
            rate: Object.values(res.totals[key])[1] as number,
          };
          res.totals[key] = newObject;
        }
        for (const key in res.averages) {
          Object.values(res.averages[key]);
          const newObject: AverageWithRate = {
            average: Object.values(res.averages[key])[0] as number,
            rate: Object.values(res.averages[key])[1] as number,
          };
          res.averages[key] = newObject;
        }
        return this.mapper.fromJson(WhiteLabelTotalWithAverageSessions, res);
      })
    );
  }

  getUsersCommentsAndRate(categories: string[]): Observable<WhiteLabelUsersCommentsWithRate> {
    return this.baseAPI
      .post(Constants.GET_APPLICATION_LATEST_COMMENTS_API_URL, { categories: categories ? [categories] : null })
      .pipe(map((res) => this.mapper.fromJson(WhiteLabelUsersCommentsWithRate, res)));
  }

  getChartStatistics(form: ChartStatisticsFilterForm): Observable<WhiteLabelChartStatistics[]> {
    const body = {
      from: form.date?.start || null,
      to: form.date?.end || null,
      type: form.type,
      categories: form.categories ? [form.categories] : undefined,
    };
    return this.baseAPI.post(Constants.GET_APPLICATION_CHART_STATISTICS_API_URL, body).pipe(
      map((res) => {
        return this.mapper.fromListJson(WhiteLabelChartStatistics, res.data);
      })
    );
  }

  getMapStatistics(): Observable<WhiteLabelMapStatisticsModel> {
    return this.baseAPI.post(Constants.GET_APPLICATION_MAP_STATISTICS, undefined).pipe(
      map((res) => {
        const data = { beneficiariesCount: res.beneficiariesCount, beneficiariesMap: res.beneficiariesMap };
        return this.mapper.fromJson(WhiteLabelMapStatisticsModel, data);
      })
    );
  }

  getPDFGendersCount(form: StatisticsFilterForm): Observable<WhiteLabelPdfGendersStatistics> {
    const body = {
      from: form.date?.start || null,
      to: form.date?.end || null,
      categories: form.categories ? [form.categories] : undefined,
    };
    return this.baseAPI.post(Constants.GET_WL_PDF_GENDER_COUNT, body).pipe(
      map((resBody) => {
        const res = {
          beneficiaries : resBody.beneficiaries?.sort((a , b)=> a?.gender?.length - b?.gender?.length),
          letters : resBody.letters?.sort((a , b)=> a?.gender?.length - b?.gender?.length),
          minutes : resBody.minutes?.sort((a , b)=> a?.gender?.length - b?.gender?.length),
          pages : resBody.pages?.sort((a , b)=> a?.gender?.length - b?.gender?.length),
          sessions : resBody.sessions?.sort((a , b)=> a?.gender?.length - b?.gender?.length)
        }
        const response = {
          beneficiaries: {
            male: res.beneficiaries?.[0]?.count,
            female: res.beneficiaries?.[1]?.count,
          },
          letters: {
            male: res.letters?.[0]?.count,
            female: res.letters?.[1]?.count,
          },
          minutes: {
            male: res.minutes?.[0]?.count,
            female: res.minutes?.[1]?.count,
          },
          pages: {
            male: res.pages?.[0]?.count,
            female: res.pages?.[1]?.count,
          },
          sessions: {
            male: res.sessions?.[0]?.count,
            female: res.sessions?.[1]?.count,
          },
        };
        return this.mapper.fromJson(WhiteLabelPdfGendersStatistics, response);
      })
    );
  }
}
